import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useMergeProps from '../../../../hooks/useMergeProps';
import useRouter from '../../../../hooks/useRouter';
import { selectUserConnected } from '../../../../selectors/user/userPrimary.selector';
import useMissionTransitionSelector from '../../hooks/useMissionTransitionSelector';

import MissionCard from './MissionCard';
import selectMissionCardContainerProps, { MissionCardContainerPropsType } from './MissionCard.selector';

type MissionCardContainerProps = {
  className?: string;
  missionId: number;
};

const MissionCardContainer = (ownProps: MissionCardContainerProps) => {
  const dispatch = useDispatch();
  const { missionId } = ownProps;
  const { history, location } = useRouter();

  const isUserConnected = useSelector(selectUserConnected);
  const selectorProps = useMemo(() => ({ missionId, history, dispatch }), [missionId, history, dispatch]);
  const selectedProps = useMissionTransitionSelector<MissionCardContainerPropsType>(
    selectMissionCardContainerProps,
    selectorProps,
    {
      disabled: !isUserConnected,
    },
  );

  const onClick = useCallback(() => {
    const hash = `#mission-details-${missionId}`;

    if (location.hash !== hash) {
      history.push({
        hash,
      });
    }
  }, [history, missionId, location]);

  const otherProps = useMemo(() => ({ onClick }), [onClick]);

  const enhancedProps = useMergeProps({ ownProps, selectedProps, otherProps });

  return <MissionCard {...enhancedProps} />;
};

export default React.memo<MissionCardContainerProps>(MissionCardContainer);
